import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% { background-position: -600px 0; }
  100% { background-position: 600px 0; }
`

export const SkeletonBase = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 1200px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
  border-radius: 4px;
`

export const SkeletonLine = styled(SkeletonBase)<{ width?: string; height?: string }>`
  height: ${({ height }) => height || '14px'};
  width: ${({ width }) => width || '100%'};
  margin-bottom: 8px;
`

export const SkeletonBox = styled(SkeletonBase)<{ height?: string }>`
  height: ${({ height }) => height || '200px'};
  width: 100%;
`

export const SkeletonCircle = styled(SkeletonBase)<{ size?: string }>`
  width: ${({ size }) => size || '60px'};
  height: ${({ size }) => size || '60px'};
  border-radius: 50%;
  flex-shrink: 0;
`
